export const debounce = <T extends unknown[]>(
  fn: (...args: T) => unknown,
  delay: number
) => {
  let timeoutID: NodeJS.Timeout;
  return (...args: T) => {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
    timeoutID = setTimeout(() => fn(...args), delay);
  };
};

export const calculateOffset = (page: number, limit: number) => {
  return (page - 1) * limit;
};

export const calculateTotalPages = (total: number, limit: number) => {
  return Math.ceil(total / limit);
};
